/* eslint-disable consistent-return */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

interface MindmapViewerProps {
  rootJson: unknown;
  isOpen: boolean;
  title: string;
}

export const MindmapViewer: FunctionComponent<MindmapViewerProps> = ({
  rootJson,
  isOpen,
  title,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeKey, setIframeKey] = useState(0);

  // При открытии обновляем key для пересоздания iframe
  useEffect(() => {
    if (isOpen && rootJson) {
      setIframeKey((prev) => prev + 1);
    }
  }, [isOpen, rootJson]);

  // Отправляем данные в iframe
  useEffect(() => {
    if (!isOpen || !rootJson || !iframeRef.current) return;

    const sendData = () => {
      if (iframeRef.current?.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          {
            type: 'setRoot',
            rootJson,
            config: {
              layoutMode: 'mindmap',
              theme: {
                background: '#1b1d21',
                gridColor: '#b9c0ca',
                blockFill: '#2a2e34',
                mutedBlockFill: '#343941',
                textColor: '#e5e8ee',
                rootTextColor: '#ffffff',
                mutedTextColor: '#9aa3af',
                linkColor: '#7fb1ff',
                selectionColor: '#ff8a5b',
                outlineColor: '#d4d8de',
                lineColor: '#7d8794',
              },
              viewportInsets: { left: 320 },
            },
          },
          '*'
        );
      }
    };

    const timer = setTimeout(sendData, 500);
    return () => clearTimeout(timer);
  }, [isOpen, rootJson, iframeKey]);

  if (!isOpen) return null;

  return (
    <iframe
      key={iframeKey}
      ref={iframeRef}
      src="/mindmap-embed.html"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        backgroundColor: '#1b1d21',
      }}
      title="Mindmap Viewer"
    />
  );
};
